import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { SupabaseAccessGateway } from './infrastructure/supabaseAccessGateway';
import { SupabaseDashboardGateway } from './infrastructure/supabaseDashboardGateway';
import { SupabaseInventoryGateway } from './infrastructure/supabaseInventoryGateway';
import { SupabaseWorkspacesGateway } from './infrastructure/supabaseWorkspacesGateway';
import { SupabaseNetworkGateway } from './infrastructure/supabaseNetworkGateway';
import { SupabaseAgencyGateway } from './infrastructure/supabaseAgencyGateway';
import { SupabaseAdminGateway } from './infrastructure/supabaseAdminGateway';
import { AccessScreen } from './ui/AccessScreen';
import { PlansScreen } from './ui/PlansScreen';
import { DashboardScreen } from './ui/DashboardScreen';
import { InventoryScreen } from './ui/InventoryScreen';
import { WorkSpacesScreen } from './ui/WorkSpacesScreen';
import { NetworkScreen } from './ui/NetworkScreen';
import { AgencyScreen } from './ui/AgencyScreen';
import { AdminScreen } from './ui/AdminScreen';
import './ui/tokens.css';

const root = document.getElementById('root');

if (root === null) {
  throw new Error('Alpha•MLS root element was not found.');
}

const accessGateway = new SupabaseAccessGateway();
const dashboardGateway = new SupabaseDashboardGateway(accessGateway);
const inventoryGateway = new SupabaseInventoryGateway(accessGateway);
const workspacesGateway = new SupabaseWorkspacesGateway(accessGateway);
const networkGateway = new SupabaseNetworkGateway(accessGateway);
const agencyGateway = new SupabaseAgencyGateway(accessGateway);
const adminGateway = new SupabaseAdminGateway(accessGateway);
const pathname = window.location.pathname;
const isPlans = pathname === '/plans';
const isDashboard = pathname === '/dashboard';
const isInventory = pathname === '/inventory';
const isWorkSpaces = pathname === '/workspaces';
const isNetwork = pathname === '/network' || pathname === '/collections';
const isAgency = pathname === '/agency' || pathname === '/business-card';
const isAdmin = pathname === '/admin' || pathname === '/admin/invitations';

createRoot(root).render(
  <StrictMode>
    {isPlans ? (
      <PlansScreen />
    ) : isDashboard ? (
      <DashboardScreen gateway={dashboardGateway} />
    ) : isInventory ? (
      <InventoryScreen gateway={inventoryGateway} />
    ) : isWorkSpaces ? (
      <WorkSpacesScreen gateway={workspacesGateway} />
    ) : isNetwork ? (
      <NetworkScreen gateway={networkGateway} />
    ) : isAgency ? (
      <AgencyScreen gateway={agencyGateway} />
    ) : isAdmin ? (
      <AdminScreen gateway={adminGateway} />
    ) : (
      <AccessScreen gateway={accessGateway} />
    )}
  </StrictMode>,
);
